
import { JobService } from "@/services";
import Vue from "vue";
import { Job } from "../../models/job";
import { MainSocketService } from "../../services/main-socket-service";
import AppDownloadReportModal from "./DownloadReportModal.vue";

export default Vue.extend({
	data() {
		return {
			running: true,
			value: null as null | any,
		};
	},
	props: {
		job: {
			type: Object as () => Job,
			required: true
		}
	},
	methods: {
		onJobComplete(value: any) {
			console.log("On job complete");
			this.value = value;
			setTimeout(() => {
				console.log("Set running to false");
				this.running = false;
			}, 1000);
		},
		onJobStop(){
			setTimeout(() =>{
				console.log("Job stopped");
				if (this.value) return;
				this.close();
			}, 500);
		},
		close() {
			this.$emit("close");
		},
	},
	async created() {
		JobService.on(`job-stopped/${this.job.getID()}`, this.onJobStop);
		MainSocketService.on(`/report/completed`, this.onJobComplete, this);
	},
	destroyed() {
		JobService.off(`job-stopped/${this.job.getID()}`, this.onJobStop);
		MainSocketService.offAll(this);
	},
	components: {
		AppDownloadReportModal
	},
	i18nEx: {
		componentPrefix: "components.reportengine"
	}

});
